document.addEventListener("variant:add",  (e) => {

    var _learnq = _learnq || [];
    const product = e.detail.items[0];

    // 1. Build the product data object using Shopify Liquid variables
    var item = {
        "Name": product.title,
        "ProductID": product.id,
        "ImageURL": product.featured_image.url,
        "Brand": product.vendor,
        "Price": product.final_price,
        "CompareAtPrice": product.original_price
    };

    console.log(item)
    _learnq.push(['track', 'Added to Cart', item]);

})